import {photo_getPhotosByUser_Api} from 'apis'
import {getId} from 'apis/model/base'
import {Image} from 'antd'
import EmptyHolder from 'components/EmptyHolder'
import {formatSimplifyDate} from 'helpers/dateUtils'
import dayjs from 'dayjs'
import React, {useContext, useRef} from 'react'
import {MdCalendarToday} from 'react-icons/md'
import EntityList from 'views/AppLocals/EntityList'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import UserContext from '../UserContext'
import {HiViewfinderCircle} from "react-icons/hi2";
import useTranslate from "../../../../modules/local/useTranslate";
import {BsCalendar2Week} from "react-icons/bs";

const MediaGridWrapper = ({children}) => (
    <div className="grid grid-cols-3 gap-1">{children}</div>
)

const MediaGroupHeader = ({label}) => (
    <div className="col-span-3 flex items-center gap-2 pt-3 pb-1.5 first:pt-0">
        <BsCalendar2Week size={14} className="text-secondary-500 flex-shrink-0"/>
        <span className="text-xs font-bold text-slate-500 uppercase tracking-widest flex-shrink-0">
            {label}
        </span>
        <div className="flex-1 border-t border-color-50"/>
    </div>
)

const PhotoItem = ({item}) => {
    const t = useTranslate()
    if (!item) return null
    return (
        <div className="relative w-full" style={{paddingTop: '100%'}}>
            <Image
                src={item.path}
                wrapperClassName="absolute top-0 left-0 w-full h-full"
                className="w-full h-full object-cover"
                preview={{
                    mask: (
                        <div className="w-full h-full flex flex-col flex-center gap-1 text-white opacity-85 hover:opacity-100  relative">
                            <HiViewfinderCircle
                                size={16}
                                className="custom-img-view-icon"
                            />
                            <span className="text-2xs tracking-wider">
                                {t('click to view')}
                            </span>
                        </div>
                    ),
                }}
            />
        </div>
    )
}

const UserMedia = ({Wrapper = 'div'}) => {
    const {user} = useContext(UserContext)
    const id = getId(user)
    const lastGroupKeyRef = useRef(null)

    if (!id) return null

    lastGroupKeyRef.current = null

    return (
        <Wrapper className="flex flex-col space-y-1">
            <EntityList
                apiInfo={photo_getPhotosByUser_Api}
                query={bindQueryParam({id})}
                renderItem={(item, index) => {
                    if (!item) return null
                    const groupKey = item.created_at
                        ? dayjs(item.created_at).local().format('YYYY-MM')
                        : null
                    const isNewGroup = !!groupKey && groupKey !== lastGroupKeyRef.current
                    if (isNewGroup) lastGroupKeyRef.current = groupKey

                    return (
                        <React.Fragment key={index}>
                            {isNewGroup && (
                                <MediaGroupHeader
                                    label={formatSimplifyDate(item.created_at, null, 'MMMM YYYY')}
                                />
                            )}
                            <PhotoItem item={item}/>
                        </React.Fragment>
                    )
                }}
                RenderEntity={React.Fragment}
                renderItemWrapper={MediaGridWrapper}
                renderEmpty={() => (
                    <div className="col-span-3 w-full flex justify-center items-center py-6">
                        <EmptyHolder/>
                    </div>
                )}
            />
        </Wrapper>
    )
}

export default UserMedia
